export { default } from './OIDCRedirect';
